import React from 'react';

import NextImage from 'next/image';

import premium from '../../../../../components/Avatar/premium.svg';
import { Text } from '../../../../../components/Text/Text';

import styles from './LayerButton.module.css';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';

interface IProps {
  layerImage: StaticImport;
  layerAlt: string;
  layerName: string;
  layerActive: boolean;
  user: { isLoggedIn: boolean; isPremium: boolean };
  onClick: () => void;
  onProModalClick: () => void;
  proLayer?: boolean;
}

export const LayerButton = ({
  layerImage,
  layerAlt,
  layerName,
  layerActive,
  user,
  onClick,
  onProModalClick,
  proLayer = true,
}: IProps) => {
  const proFeaturesUnlocked = (user.isLoggedIn && user.isPremium) || !proLayer;

  return (
    <div className="flex flex-col justify-center">
      <div className={`flex ${styles.hoverTrigger} items-center justify-center`}>
        <Text
          as="div"
          variant="xs"
          className={`z-mid absolute left-20 rounded-full px-3 py-1.5 whitespace-nowrap text-white ${styles.hoverTarget}`}
        >
          {layerName}
        </Text>
        <button
          type="button"
          onClick={proFeaturesUnlocked ? onClick : onProModalClick}
          className={`relative flex rounded-md border-2 p-0.5 sm:static ${
            layerActive ? 'border-pike' : 'border-white'
          }`}
        >
          <NextImage alt={layerAlt} src={layerImage} className="w-14 min-w-[56px] rounded-md" />
          {!proFeaturesUnlocked && (
            <div className="absolute -mt-2 ml-11 sm:left-16 sm:-ml-1">
              <NextImage
                className="self-auto justify-self-end"
                style={{
                  gridColumn: 1,
                  gridRow: 1,
                  position: 'absolute',
                  marginLeft: '5px',
                  marginTop: '-5px',
                }}
                alt="Premium user"
                width={17}
                height={17}
                src={premium}
              />
            </div>
          )}
        </button>
      </div>
      <Text as="div" variant="xs" className="text-center sm:hidden">
        {layerName}
      </Text>
    </div>
  );
};
